import { startOfDay, startOfMonth } from 'date-fns';

import { ChartViewMode } from 'features/dashboard/ts/ChartViewMode';
import { startOfWeek } from 'features/app/utils/startOfWeek';

export const getRangeStart = (rangeEnd: Date, chartMode: ChartViewMode, summaryMode = false) => {
  switch (chartMode) {
    case ChartViewMode.Daily:
      return startOfDay(rangeEnd);
    case ChartViewMode.Weekly:
      if (summaryMode) {
        return rangeEnd;
      }
      return startOfWeek(rangeEnd);
    case ChartViewMode.Monthly:
      if (summaryMode) {
        return startOfMonth(rangeEnd);
      }
      return startOfWeek(startOfMonth(rangeEnd));
  }
};
